import axios from 'axios';
import qs from 'qs';
import cookie from 'js-cookie';
import vm from '../../main'
import Vue from 'vue'
const baseUrl = "http://47.75.105.162:3100";//基本url
// const baseUrl = "http://172.18.74.128:3200";//基本url
// const baseUrl = "http://172.18.74.129:8000";//基本url
// const baseUrl = "http://172.18.74.130:3200";//基本url
// const baseUrl = "http://172.18.74.128:3100";//基本url
const timeOut = 100000;//请求超时时间
//创建一个axios实例
const service = axios.create({
  baseURL: baseUrl,
  timeout: timeOut
})

let isLoading = 0
const CancelToken = axios.CancelToken;
let cancel;
let cancelToken = new CancelToken(
  function executor(c) {
    cancel = c;
  });

//创建request拦截器
service.interceptors.request.use(
  config => {
    // debugger
    // 判断cookie里面是否有名称是 token数据
    if (cookie.get('au')) {
      // 把获取cookie值放到header里面
      config.headers.Authorization = 'Bearer' + ' ' + cookie.get('au');
    }
    config.paramsSerializer = params => {
      return qs.stringify(params, { indices: false })
    }
    //config.cancelToken = cancelToken
    isLoading++
    return config
  },
  err => {
    return Promise.reject(err)
  }
);

//创建response拦截器
service.interceptors.response.use(
  // 这将会在之后统一进行配置
  response => {
    isLoading--;
    switch (response.data.code) {
      case 205: {
        if (response.data.token) {
          cookie.set('au', response.data.token);
        }
        break;
      }
      case 404: {
        console.log("请求出错！");
        response.data.data = -1;
        break;
      }
      default: break;
    }
    return response.data;
  },
  err => {
    isLoading--;
    console.log("请求失败！");
    if (err.response.status === 403 && err.response.data.error === "token over time") {
      // 未登录或token过期
      console.log("token expired!");
      if (cookie.get('au')) {
        cookie.remove('au');
        //this.$global.error(this, "登录过期，请重新登录！", {name:'AdminLogin'});
        Vue.prototype.$message({
          message: "登录过期，请重新登录！",
          type: 'error',
          duration: '2000',
          onClose: () => {
            vm.$router.push({ name: 'AdminLogin' });
          }
        });
      }
      else {
        //this.$global.error(this, "您还未登录，请先登录！", {name:'AdminLogin'});
        Vue.prototype.$message({
          message: "您还未登录，请先登录！",
          type: 'error',
          duration: '2000',
          onClose: () => {
            vm.$router.push({ name: 'AdminLogin' });
          }
        });
      }
    }
    // 返回接口返回的错误信息
    return Promise.reject(err.response);
  }
);
// 取消所有请求
export function RequestCancel() {
  if (isLoading > 0) {
    cancel('cancel');
    cancelToken = new CancelToken(function executor(c) {
      cancel = c;
    })
  }
}
export default service;







// WEBPACK FOOTER //
// ./src/apis/service/index.js